export const Logo = ({ className = "", light = false }) => {
  const src = `${process.env.PUBLIC_URL || ""}/${light ? "brand-logo-light.png" : "brand-logo.png"}`;
  return (
    <span className={`inline-flex items-center ${className}`} data-testid="brand-logo">
      <img src={src} alt="real & state" className="h-9 w-auto object-contain" />
    </span>
  );
};
